import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { adminApi } from '../api';

export default function DashboardPage() {
  const [stats, setStats] = useState({ products: 0, companyName: '...' });
  const [resetOpen, setResetOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [resetting, setResetting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = () =>
    Promise.all([adminApi.getProducts(), adminApi.getSettings()])
      .then(([products, settings]) => {
        setStats({
          products: products.length,
          companyName: settings.companyName,
          hasOpenaiApiKey: Boolean(settings.hasOpenaiApiKey),
        });
      })
      .catch((err) => console.error(err));

  useEffect(() => {
    load();
  }, []);

  const handleReset = async () => {
    setResetting(true);
    setError('');
    setMessage('');
    try {
      const result = await adminApi.factoryReset();
      setResetOpen(false);
      setConfirmText('');
      setMessage(`${result.message} Eliminati ${result.deletedProducts} prodotti.`);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setResetting(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Dashboard
      </Typography>
      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography color="text.secondary">Azienda</Typography>
              <Typography variant="h5">{stats.companyName}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card component={RouterLink} to="/admin/prodotti" sx={{ textDecoration: 'none' }}>
            <CardContent>
              <Typography color="text.secondary">Prodotti in catalogo</Typography>
              <Typography variant="h5">{stats.products}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card component={RouterLink} to="/admin/impostazioni" sx={{ textDecoration: 'none' }}>
            <CardContent>
              <Typography color="text.secondary">Chiave API OpenAI</Typography>
              <Typography variant="h5">
                {stats.hasOpenaiApiKey ? 'Configurata' : 'Mancante'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Card sx={{ mt: 4, border: '1px solid', borderColor: 'error.light' }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Ripristina white-label
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 640 }}>
            Azzera catalogo, branding, prompt e contatti e torna allo stato iniziale.
            Restano salvati accesso admin e chiave OpenAI. L’operazione non si può annullare.
          </Typography>
          <Button color="error" variant="outlined" onClick={() => setResetOpen(true)}>
            Azzera e ripristina
          </Button>
        </CardContent>
      </Card>

      <Dialog open={resetOpen} onClose={() => !resetting && setResetOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Conferma azzeramento</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Verranno eliminati tutti i prodotti (anche migliaia) e ripristinati nome azienda, colori,
            prompt e impostazioni contatti. Scrivi <b>AZZERA</b> per confermare.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label="Scrivi AZZERA"
            value={confirmText}
            onChange={(event) => setConfirmText(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResetOpen(false)} disabled={resetting}>
            Annulla
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={confirmText.trim().toUpperCase() !== 'AZZERA' || resetting}
            onClick={handleReset}
          >
            {resetting ? 'Azzeramento...' : 'Conferma azzeramento'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
